import React, { useMemo } from 'react';
import { useSelectCurrentOrder } from '../../../../selectors/order/selectCurrentOrder';
import { SectionName } from './SectionName';
import { ePartyPurpose } from '../../../../ui-toolkit/enums/ePartyPurpose';
import { ePartyType } from '../../../../ui-toolkit/enums/ePartyType';
import { FullNameOfPerson } from '../../../../ui-toolkit/orders/interfaces/IParty';

export interface ITitleOwnershipPartyProps {
  purpose: ePartyPurpose;
}

export const TitleOwnershipParty: React.FC<ITitleOwnershipPartyProps> = ({ purpose }) => {
  const {
    data: { parties },
  } = useSelectCurrentOrder();

  const filteredParties = useMemo(() => parties.filter((party) => party.purpose === purpose), [parties, purpose]);

  return (
    <div className={`flex gap-4 border-t border-gray-200 pb-4 pt-4`}>
      <SectionName>{purpose === ePartyPurpose.buyer ? 'Grantee' : 'Grantor'}</SectionName>
      <section className="w-[400px]">
        <table className="w-full">
          <thead>
            <tr className="mb-2 h-8">
              <th className="w-48 text-sm font-normal not-italic leading-5">Name</th>
              <th className="w-48 text-sm font-normal not-italic leading-5">Marital Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredParties.map((party) => (
              <tr key={party.id} className="mb-2 h-8">
                <td className="w-48">
                  {party.type === ePartyType.person ? FullNameOfPerson(party) : party.entity_name}
                </td>
                <td className="w-48">{party.type === ePartyType.person ? party.marital_status : 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};
